export default "__VITE_ASSET__b2fe1179__"